import { Injectable } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { Observable, of } from 'rxjs';
import { EFilterType, IFilterOptions, IFilterSelectOption } from './filter.type';

@Injectable()
export class BixiFilterService {

  getBoolean(valOrFunc: undefined | boolean | (() => boolean), def: boolean) {
    let result = valOrFunc ?? def;
    if (typeof result === 'function') {
      result = result();
    }
    return result;
  }

  genOptions(options: IFilterOptions): IFilterOptions {
    return options
      .map(option => {
        const visible = this.getBoolean(option.visible, true);
        const disabled = this.getBoolean(option.disabled, false);
        if (option.type === EFilterType.select) {
          const o = option as IFilterSelectOption;
          return {
            ...o,
            visible,
            disabled,
            onSearch: o.onSearch ?? (() => { }),
            onChange: o.onChange ?? (() => { }),
            options: o.options instanceof Observable ? o.options : of(o.options)
          };
        }

        return {
          ...option,
          visible,
          disabled
        };
      })
      .filter((o: NzSafeAny) => o.visible);
  }
}
